import { usePermissions } from "@/hooks/usePermissions";
import StrategyView from "../../views/StrategyView";
import GuestStrategyView from "./GuestStrategyView";

/**
 * /dashboard/strategy. The team gets the strategy workspace; a Guest (a brand's
 * client) reads only the strategies sent to them.
 */
export default function StrategyRoute() {
  const { isGuest } = usePermissions();
  return isGuest ? <GuestStrategyView /> : <StrategyView />;
}
